import { getLocation } from "./api";
import { activeCategories, currentAlerts, sortAlertsChronologically } from "./state";
import { singleCardHtml } from "./regionDetail";
import type { Alert } from "./types";

let panelEl: HTMLElement;
let listEl: HTMLElement;
let toggleButton: HTMLButtonElement;
let closeButtonEl: HTMLButtonElement;

const locationNameById = new Map<number, string>();

function myLocationAlerts(): Alert[] {
  return sortAlertsChronologically(
    currentAlerts.filter((alert) => alert.scope_kind === "location" && activeCategories.has(alert.category)),
  );
}

async function resolveLocationNames(alerts: Alert[]): Promise<Map<number, string>> {
  const ids = [...new Set(alerts.map((alert) => Number(alert.scope_id)))];
  const missingIds = ids.filter((id) => !locationNameById.has(id));
  await Promise.all(
    missingIds.map(async (id) => {
      try {
        const location = await getLocation(id);
        locationNameById.set(id, location.name);
      } catch {
        // Not cached — retried on the next call instead of showing this
        // placeholder forever after a transient failure.
      }
    }),
  );
  return locationNameById;
}

export function isMyAlertsOpen(): boolean {
  return !panelEl.classList.contains("hidden");
}

export function hideMyAlerts(): void {
  const wasOpen = isMyAlertsOpen();
  panelEl.classList.add("hidden");
  toggleButton.classList.remove("active-toggle");
  if (wasOpen) toggleButton.focus();
}

let renderSeq = 0;

export async function renderMyAlerts(): Promise<void> {
  const seq = ++renderSeq;
  const alerts = myLocationAlerts();
  const names = await resolveLocationNames(alerts);
  if (seq !== renderSeq) return;
  const now = new Date();
  listEl.innerHTML =
    alerts
      .map((alert) => singleCardHtml(alert, now, names.get(Number(alert.scope_id)) ?? `lokalizacja #${alert.scope_id}`))
      .join("") || '<div class="alert-card-empty">Brak aktywnych alertów z Twoich progów pogodowych.</div>';
}

export async function showMyAlerts(): Promise<void> {
  panelEl.classList.remove("hidden");
  toggleButton.classList.add("active-toggle");
  await renderMyAlerts();
  closeButtonEl.focus();
}

export function initMyAlerts(ids: {
  panel: string;
  list: string;
  closeButton: string;
  toggleButton: string;
  onShow: () => void;
}): void {
  panelEl = document.getElementById(ids.panel) as HTMLElement;
  listEl = document.getElementById(ids.list) as HTMLElement;
  toggleButton = document.getElementById(ids.toggleButton) as HTMLButtonElement;
  closeButtonEl = document.getElementById(ids.closeButton) as HTMLButtonElement;

  closeButtonEl.addEventListener("click", hideMyAlerts);
  toggleButton.addEventListener("click", () => {
    if (isMyAlertsOpen()) {
      hideMyAlerts();
    } else {
      ids.onShow();
      void showMyAlerts();
    }
  });
}
